export default __webpack_public_path__ + "static/media/IncredibleAnimalsSpeeders_09.477adc10.png";